import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

type ThemeOptions = 'light' | 'dark';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    private readonly renderer: Renderer2;
    private readonly document = inject(DOCUMENT);

    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    getDocumentTheme(): ThemeOptions {
        const documentTheme = this.document.documentElement.dataset['theme'];

        if (documentTheme === 'dark') {
            return 'dark';
        }

        return 'light';
    }

    getSystemTheme(): ThemeOptions {
        const dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        if (dark) {
            return 'dark';
        }

        return 'light';
    }

    switchTheme() {
        const current = this.getDocumentTheme();

        if (current === 'dark') {
            this.renderer.setAttribute(
                this.document.documentElement,
                'data-theme',
                'light',
            );
            localStorage.setItem('ads-theme', 'light');
            return;
        }
        this.renderer.setAttribute(
            this.document.documentElement,
            'data-theme',
            'dark',
        );
        localStorage.setItem('ads-theme', 'dark');
    }

    getThemeToggleLabel(): string {
        return this.getDocumentTheme() === 'dark' ? 'Light Mode' : 'Dark Mode';
    }

    setInitialTheme() {
        const local = localStorage.getItem('ads-theme');

        if (!local) {
            this.renderer.setAttribute(
                this.document.documentElement,
                'data-theme',
                this.getSystemTheme(),
            );
            return;
        }

        this.renderer.setAttribute(
            this.document.documentElement,
            'data-theme',
            local,
        );
    }
}
